import { CaretRight } from "@phosphor-icons/react";
import { toneClasses } from "@/lib/morning";

// One reusable hero tile. Always clickable (drills to a list view).
export const HeroTile = ({ testid, icon: Icon, label, value, sub, tone = "neutral", onClick }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    className="group text-left bg-card border border-border rounded-xl p-4 hover:shadow-md hover:border-[hsl(var(--accent)/0.5)] transition-all duration-200 flex flex-col gap-2 outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--accent))]"
  >
    <div className="flex items-center justify-between">
      <span className="eyebrow text-[10px] text-muted-foreground flex items-center gap-1.5">
        {Icon && <Icon size={13} weight="regular" className="opacity-70" />}
        {label}
      </span>
      <CaretRight size={13} className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
    </div>
    <div className="flex items-baseline gap-2">
      <span className="font-serif text-3xl leading-none tabular-nums">{value}</span>
      {tone !== "neutral" && (
        <span className={`inline-block h-2 w-2 rounded-full ${toneClasses(tone).split(" ")[0]}`} />
      )}
    </div>
    <p className="text-xs text-muted-foreground leading-snug min-h-[16px]">{sub}</p>
  </button>
);
